<template lang="pug">
  div
    v-container(fluid, grid-list-md)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-text
              .text-xs-center.py-5(v-if='!listImageURL || listImageURL.length < 1')
                .headline {{ $t('messages.noMediaFound') | capitalize }}
              v-container(v-else fluid)
                v-btn(:to='"/viewer/" + this.gestationInteraction.iuid' target="_blank") Visualizador
                v-layout(row, wrap)
                  v-flex(v-for='(image, i) in listImageURL', :key='image', xs12, md4)
                    v-card(flat, tile)
                      v-img(:src='image', @click='slideIndex = i', style='background-color: black; height: 250px;')
                        v-layout(slot='placeholder', fill-height, align-center, justify-center, ma-0)
                          v-progress-circular(indeterminate, color='grey lighten-5')
                  vue-gallery(:images='listImageURL', :index='slideIndex', @close='slideIndex = null')
</template>

<script>
import VueGallery from 'vue-gallery'
import { mapState } from 'vuex'

const getImageURL = 'https://app.ultrahealth.care/functions/healthcareImage?id='
export default {
  name: 'Medias',

  components: {
    VueGallery
  },

  computed: {
    ...mapState({
      dicomParams: state => state.ultraFetal.dicomParams,
      patient: state => state.ultraFetal.patient,
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction
    }),
    listImageURL () {
      return this.dicomParams.map(item => getImageURL + item.iuid)
    }
  },

  data () {
    return {
      studies: [{}],
      slideIndex: null
    }
  },

  mounted () {
    setTimeout(() => {
      if (!this.dicomParams || !this.dicomParams.iuid) {
        const interationDateKey = 'gestationalAge.info.interationDate'
        this.$store.dispatch('ultraFetal/getDicomParams', { identity: this.gestationInteraction.company.identity, patId: this.patient.patId, date: this.gestationInteraction.forms[interationDateKey] })
      }
    }, 2000)
  }
}
</script>

<style>
  .blueimp-gallery-display {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Medias.vue